import React, { useState } from 'react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { ClipboardCheck, Home, ShoppingBag, Grid3X3 } from 'lucide-react';

const COUNT_STAGES = {
  graft: { status: 'accepted', label: 'How many cells were accepted?', field: 'cells_accepted' },
  capped: { status: 'capped', label: 'How many cells are capped?', field: 'cells_capped' }
};

export const StageActions = ({ batch, stageKey, onBulkStatus, onTransfer, onGoToNucs, onOpenCells, onListQueens }) => {
  const cfg = COUNT_STAGES[stageKey];
  const [count, setCount] = useState('');
  const [saving, setSaving] = useState(false);
  const total = batch.cells_grafted || 0;

  const save = async () => {
    setSaving(true);
    await onBulkStatus(batch.id, cfg.status, parseInt(count));
    setSaving(false);
    setCount('');
  };

  return (
    <div data-testid={`stage-actions-${batch.id}`} className="mt-3 rounded-lg border border-sky-200 bg-sky-50/60 p-3">
      <p className="text-xs font-semibold text-sky-800 uppercase tracking-wide mb-2 flex items-center gap-1"><ClipboardCheck className="h-3.5 w-3.5" /> Record this step</p>
      {cfg && (
        <div className="flex flex-wrap items-end gap-2 mb-2">
          <div>
            <label className="text-sm text-stone-700 block mb-1">{cfg.label} <span className="text-stone-400">(of {total}, currently {batch[cfg.field] || 0})</span></label>
            <Input data-testid={`stage-count-input-${batch.id}`} type="number" min="0" max={total} value={count} onChange={(e) => setCount(e.target.value)} className="w-28 h-9 bg-white" placeholder="0" />
          </div>
          <Button data-testid={`stage-count-save-${batch.id}`} size="sm" disabled={count === '' || saving || parseInt(count) > total || parseInt(count) < 0} onClick={save} className="bg-sky-600 hover:bg-sky-700 h-9">
            {saving ? 'Saving…' : `Mark ${cfg.status}`}
          </Button>
          <p className="text-xs text-stone-500 w-full">The rest of the in-progress cells will be marked as failed. You can still fine-tune individual cells.</p>
        </div>
      )}
      <div className="flex flex-wrap gap-2">
        {stageKey === 'transfer' && (
          <Button data-testid={`stage-transfer-btn-${batch.id}`} size="sm" onClick={() => onTransfer(batch)} className="bg-indigo-600 hover:bg-indigo-700"><Home className="h-4 w-4 mr-1" /> Transfer cells to Nucs</Button>
        )}
        {['emerge', 'mating', 'check'].includes(stageKey) && (
          <Button data-testid={`stage-nucs-btn-${batch.id}`} size="sm" onClick={onGoToNucs} className="bg-blue-600 hover:bg-blue-700"><Home className="h-4 w-4 mr-1" /> Go to Mating Nucs</Button>
        )}
        {stageKey === 'check' && (
          <Button data-testid={`stage-list-btn-${batch.id}`} size="sm" onClick={() => onListQueens(batch.id)} className="bg-teal-600 hover:bg-teal-700"><ShoppingBag className="h-4 w-4 mr-1" /> List queens for sale</Button>
        )}
        <Button data-testid={`stage-open-cells-${batch.id}`} size="sm" variant="outline" onClick={() => onOpenCells(batch.id)} className="border-sky-300 text-sky-700 bg-white"><Grid3X3 className="h-4 w-4 mr-1" /> Open batch cells</Button>
      </div>
    </div>
  );
};
